module.exports = __webpack_public_path__ + "static/media/sub5.4cb3690f.png";